module.exports = __webpack_public_path__ + "img/77.74c4a50c.jpg";